export const DICAMBA_KEYWORD = 'dicamba';
